import { render, staticRenderFns } from "./releaseDialog.vue?vue&type=template&id=6cbc3b27&"
import script from "./releaseDialog.vue?vue&type=script&lang=js&"
export * from "./releaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./releaseDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports